<ng-container class="nes-flex-col" *ngIf="message">
  <div [class]="class">
    <nes-message-inline
      id="message"
      nesId="message"
      data-pw="message"
      [label]="message.label | translate: message.translateParams"
      [type]="message.messageType ? 'informative' : 'error'"
      [icon]="message.messageType ? 'info' : 'alert'"
      close="true"
      (nesOnCloseClick)="close.emit(message)"
    >
      {{ message.body | translate }}
    </nes-message-inline>
  </div>
</ng-container>
